import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Responses/Requests
import { Result } from '@/main/models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { saveAffectedType } from './index';

// Api's
import { affectedTypeApi } from '@/main/api';
import {
  errorBoundaryReduxSaga,
  renderErrorReduxSaga
} from '@/main/services/utils';

export function* getAffectedTypeSaga() {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      affectedTypeApi.getDomain
    );

    if (response.data.result) {
      yield put(saveAffectedType(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveAffectedType(null, true, resultError.messagesDataError));
    }
  }
}
